import { getClinicalDataApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { ClinicalDataPayload, ClinicalDataResponse, ObjectType } from './types/types';

export const addClinicalData = async (
  object_type: ObjectType,
  payload: ClinicalDataPayload,
  userRole?: string,
): Promise<ClinicalDataResponse> => {
  const prefix = getClinicalDataApiPrefix(userRole);
  const path = prefix ? `${prefix}/clinical_data/${object_type}` : `/clinical-data/${object_type}`;
  const { data } = await client.post<ClinicalDataResponse>(path, payload);

  return data;
};
